export const ThemeMode = {
  Light: 'light',
  Dark: 'dark',
  System: 'system',
} as const;

export type ThemeModeValue = (typeof ThemeMode)[keyof typeof ThemeMode];

export const THEME_STORAGE_KEY = 'beetegre_theme';
